import { useMemo } from 'react';
import { FeatureHealthStatus, FeatureItem } from './FeatureTile/FeatureTile';
import { useTranslation } from 'react-i18next';

export const useFeatureStatus = (
    hasErrors?: boolean,
    lastSuccessOn?: string,
    lastErrorOn?: string
): FeatureHealthStatus => {
    return useMemo(() => {
        if (!(hasErrors !== undefined && lastSuccessOn && lastErrorOn)) {
            return 'Unknown';
        }

        if (!hasErrors) {
            return 'Ok';
        }

        const lastSuccessDate = new Date(lastSuccessOn);

        if (isNaN(lastSuccessDate.getTime())) {
            return 'Unknown';
        }

        const lastErrorDate = new Date(lastErrorOn);

        if (isNaN(lastErrorDate.getTime())) {
            return 'Unknown';
        }

        return lastSuccessDate > lastErrorDate ? 'Warning' : 'Error';
    }, [hasErrors, lastSuccessOn, lastErrorOn]);
};

export const useIssueFeatureItems = (
    errorCount?: number,
    status?: FeatureHealthStatus
): FeatureItem[] => {
    const { t } = useTranslation();

    return useMemo(() => {
        if (errorCount === undefined) {
            return [];
        }

        if (errorCount < 1) {
            return [
                {
                    id: 'Health_NoIssues',
                    label: t('Health_NoIssues'),
                    status: 'Ok',
                },
            ];
        }

        return [
            {
                id: 'Health_IssuesFound',
                label: t('Health_IssuesFound').replace(
                    '{count}',
                    errorCount.toString()
                ),
                status: status === 'Error' ? 'Error' : 'Warning',
            },
        ];
    }, [errorCount, status, t]);
};
